import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TextInput } from '../../shared/components/form-fields/text-input/text-input';
import { Button } from '../../shared/components/ui/buttons/gradient-btn/button';
import { SectionIntro } from '../../shared/components/ui/section-intro/section-intro';
import { AppService } from '../../core/services/app.service';
import { UserService } from '../../core/services/user.service';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsStore } from '../../state/user-settings.repository';
import { ForgotPassword } from '../../core/components/forgot-password/forgot-password';

@Component({
  selector: 'andor-user-login',
  standalone: true,
  imports: [AsyncPipe, TranslatePipe, TextInput, Button, SectionIntro, ForgotPassword],
  templateUrl: './user-login.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './user-login.scss',
})
export class UserLogin {
  password = new FormControl('', [Validators.required, Validators.minLength(6)]);

  constructor(
    public appService: AppService,
    public userService: UserService,
    public userSettingsStore: UserSettingsStore
  ) {}
}
